/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import * as z from "zod"

import {
  AcceptTeamInvitationInput,
  ActiveUsers,
  ApiError,
  ArticleNumberSearchResults,
  AttachmentAcceptedFileType,
  AttachmentEntities,
  AttachmentEntity,
  AttachmentType,
  AttachmentUrl,
  AttributesTableCell,
  ChangeProjectOwnerInput,
  ClarificationRequest,
  Comment,
  CommentAttributes,
  CommentInputData,
  ComponentData,
  CreateAttachmentInput,
  CreateAttachmentLinkInput,
  CreateClarificationRequestInput,
  CreateDimConfigurationInput,
  CreateFloorInput,
  CreateFollowUpConfigurationInput,
  CreateProductPositionInput,
  CreateProjectImportInput,
  CreateProjectInput,
  CreateRoomInput,
  CreateShareLinkInput,
  CreateSpecialPriceGroupInput,
  CreateTeamInput,
  CreateTeamMemberInput,
  DataTable,
  DataTableCell,
  DeleteResponse,
  DeliveryTimeActiveImport,
  DimConfiguration,
  DimensioningOption,
  DimensioningParameter,
  DuplicateEntityInput,
  ExternalDimensioningConfiguration,
  ExternalDimensioningResult,
  ExternalDimensioningResultInput,
  ExternalDimensioningSupplementaryText,
  ExternalDimensioningSupplementaryTextInput,
  ExternalDimensioningTechnicalDataDllVersion,
  ExternalDimensioningTechnicalDataInput,
  ExternalDimensioningTechnicalDataTable,
  ExternalDimensioningTechnicalInput,
  ExternalDimensioningTechnicalInputInput,
  ExternalDimensioningTransferData,
  ExternalDimensioningTransferDataInput,
  ExternalDimensioningVariantKeyData,
  ExternalDimensioningVariantKeyDataInput,
  ExternalUsersDailyOverview,
  ExternalUsersDailyOverviewLastDays,
  Floor,
  FloorPrice,
  FollowUpConfiguration,
  Health,
  InflationSurcharge,
  JsonapiRelationshipData,
  NeoletterUserProfile,
  NeoletterUserProfileCustomFields,
  NeoletterUserProfileCustomFieldsInput,
  NeoletterUserProfileInput,
  Parent,
  PhysicalAttribute,
  PriceGroup,
  PriceGroups,
  PriceList,
  Process,
  ProcessOptions,
  ProductAttribute,
  ProductConfigurationModel,
  ProductConfigurationModelDimInfo,
  ProductConfigurationModelFollowUp,
  ProductConfigurationModels,
  ProductConfigurationResponse,
  ProductDeliveryTime,
  ProductDimensioning,
  ProductInformation,
  ProductInformationTextField,
  ProductPicture,
  ProductPosition,
  ProductPositionAddon,
  ProductPositionInstallationReference,
  ProductPositionInstallationReferenceInput,
  ProductPrice,
  ProfileDeleteCodeSubmitInput,
  Project,
  ProjectAttachmentCategories,
  ProjectHistory,
  ProjectHistoryChange,
  ProjectHistoryEntity,
  ProjectHistoryEntry,
  ProjectHistoryLinks,
  ProjectHistoryProject,
  ProjectHistoryUser,
  ProjectImport,
  ProjectImportError,
  ProjectImportProjectFieldsInput,
  ProjectKpi,
  ProjectPermissions,
  ProjectPhase,
  ProjectPrice,
  ProjectTeamId,
  ProjectUi,
  ProjectUiInput,
  ProjectsCount,
  ProjectsDailyOverview,
  Registrations,
  Room,
  RoomPrice,
  SelectOptionType,
  ShareLink,
  SpecialPriceGroup,
  Team,
  TeamInvitation,
  TeamMember,
  TeamProjects,
  UpdateAttachmentInput,
  UpdateClarificationRequestInput,
  UpdateDimConfigurationInput,
  UpdateFloorInput,
  UpdateFollowUpConfigurationInput,
  UpdateProductPositionInput,
  UpdateProjectInput,
  UpdateRoomInput,
  UpdateTeamInput,
  UpdateTeamMemberInput,
  User,
  UserKpi,
  UserPermission,
  UserRoles,
  UsersCount,
  UsersDailyOverview,
  VerifyCodeInput,
  VerifyCodeInputResponse
} from "./graphql"

type definedNonNullAny = {}

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny =>
  v !== undefined && v !== null

export const definedNonNullAnySchema = z
  .any()
  .refine(v => isDefinedNonNullAny(v))

export function ApiErrorSchema() {
  return z.object({
    __typename: z.literal("APIError"),
    cause: z.any().nullish(),
    code: z.string(),
    message: z.string().nullish()
  })
}

export function AcceptTeamInvitationInputSchema() {
  return z.object({
    id: z.string(),
    invitationAccepted: z.boolean()
  })
}

export function ActiveUsersSchema() {
  return z.object({
    __typename: z.literal("ActiveUsers"),
    external: z.number()
  })
}

export function ArticleNumberSearchResultsSchema() {
  return z.object({
    __typename: z.literal("ArticleNumberSearchResults"),
    id: z.string(),
    variantKey: z.string().nullish()
  })
}

export function AttachmentAcceptedFileTypeSchema() {
  return z.object({
    __typename: z.literal("AttachmentAcceptedFileType"),
    categories: z.array(z.string()),
    createdAt: z.string(),
    extension: z.string(),
    id: z.string(),
    mimeType: z.string(),
    updatedAt: z.string()
  })
}

export function AttachmentEntitiesSchema() {
  return z.object({
    __typename: z.literal("AttachmentEntities"),
    count: z.number(),
    entities: z.array(z.lazy(() => ProjectElementSchema())),
    id: z.string()
  })
}

export function AttachmentEntitySchema() {
  return z.object({
    __typename: z.literal("AttachmentEntity"),
    displayPosition: z.string().nullish(),
    id: z.string(),
    label: z.string().nullish(),
    number: z.string().nullish(),
    title: z.string().nullish(),
    type: z.string(),
    variantKey: z.string().nullish()
  })
}

export function AttachmentTypeSchema() {
  return z.object({
    __typename: z.literal("AttachmentType"),
    category: z.string().nullish(),
    contentLength: z.number().nullish(),
    createdAt: z.string().nullish(),
    extension: z.string().nullish(),
    fileName: z.string(),
    id: z.string(),
    linkedEntitiesCount: z.number().nullish(),
    mimeType: z.string().nullish(),
    name: z.string().nullish(),
    position: z.number().nullish(),
    readUrl: z.string(),
    title: z.string().nullish(),
    updatedAt: z.string().nullish(),
    writeUrl: z.lazy(() => AttachmentUrlSchema().nullish())
  })
}

export function AttachmentUrlSchema() {
  return z.object({
    __typename: z.literal("AttachmentURL"),
    fields: z.any(),
    url: z.string()
  })
}

export function AttributesTableCellSchema() {
  return z.object({
    __typename: z.literal("AttributesTableCell"),
    index: z.number(),
    value: z.string()
  })
}

export function ChangeProjectOwnerInputSchema() {
  return z.object({
    id: z.string(),
    team: z.string()
  })
}

export function ClarificationRequestSchema() {
  return z.object({
    __typename: z.literal("ClarificationRequest"),
    content: z.string(),
    createdAt: z.string(),
    id: z.string(),
    lastUpdatedBy: z.lazy(() => UserSchema().nullish()),
    updatedAt: z.string()
  })
}

export function CommentSchema() {
  return z.object({
    __typename: z.literal("Comment"),
    content: z.string(),
    id: z.string()
  })
}

export function CommentAttributesSchema() {
  return z.object({
    content: z.string().nullish()
  })
}

export function CommentInputDataSchema() {
  return z.object({
    attributes: z.lazy(() => CommentAttributesSchema().nullish()),
    id: z.string(),
    type: z.string()
  })
}

export function ComponentDataSchema() {
  return z.object({
    __typename: z.literal("ComponentData"),
    error: z.string().nullish(),
    generalProductDescription: z.string().nullish(),
    key: z.string().nullish(),
    name: z.string().nullish(),
    position: z.number().nullish(),
    productPositionDescription: z.string().nullish(),
    technicalDataDescription: z.string().nullish()
  })
}

export function CreateAttachmentInputSchema() {
  return z.object({
    category: z.string().nullish(),
    fileName: z.string(),
    id: z.string(),
    position: z.number().nullish(),
    title: z.string().nullish()
  })
}

export function CreateAttachmentLinkInputSchema() {
  return z.object({
    attachmentId: z.string()
  })
}

export function CreateClarificationRequestInputSchema() {
  return z.object({
    content: z.string()
  })
}

export function CreateDimConfigurationInputSchema() {
  return z.object({
    dimensioningKey: z.string().nullish(),
    id: z.string().nullish(),
    isActive: z.boolean().nullish(),
    productName: z.string(),
    productType: z.string()
  })
}

export function CreateFloorInputSchema() {
  return z.object({
    id: z.string(),
    label: z.string().nullish(),
    position: z.number().nullish(),
    remark: z.string().nullish()
  })
}

export function CreateFollowUpConfigurationInputSchema() {
  return z.object({
    isActive: z.boolean().nullish(),
    label: z.string().nullish(),
    position: z.number().nullish(),
    sourceProductName: z.string(),
    targetProductName: z.string()
  })
}

export function CreateProductPositionInputSchema() {
  return z.object({
    configurationKey: z.string().nullish(),
    dimensioning: z.lazy(() =>
      ExternalDimensioningResultInputSchema().nullish()
    ),
    displayPosition: z.string().nullish(),
    id: z.string(),
    isAlternative: z.boolean().nullish(),
    label: z.string().nullish(),
    parent: z.lazy(() => JsonapiRelationshipDataSchema().nullish()),
    position: z.number().nullish(),
    price: z.number().nullish(),
    priceGroup: z.string().nullish(),
    quantity: z.number(),
    references: z
      .array(z.lazy(() => ProductPositionInstallationReferenceInputSchema()))
      .nullish(),
    remark: z.string().nullish(),
    variantKey: z.string()
  })
}

export function CreateProjectImportInputSchema() {
  return z.object({
    id: z.string(),
    projectFields: z.lazy(() => ProjectImportProjectFieldsInputSchema()),
    s3Key: z.string()
  })
}

export function CreateProjectInputSchema() {
  return z.object({
    description: z.string().nullish(),
    id: z.string().nullish(),
    inflationSurcharge: z.number().nullish(),
    position: z.number().nullish(),
    priceList: z.string().nullish(),
    title: z.string(),
    ui: z.lazy(() => ProjectUiInputSchema().nullish())
  })
}

export function CreateRoomInputSchema() {
  return z.object({
    airVolumePerArea: z.number().nullish(),
    airVolumePerPerson: z.number().nullish(),
    area: z.number().nullish(),
    eha: z.number().nullish(),
    eta: z.number().nullish(),
    height: z.number().nullish(),
    id: z.string(),
    ida: z.number().nullish(),
    label: z.string().nullish(),
    number: z.string(),
    oda: z.number().nullish(),
    personsNumber: z.number().nullish(),
    position: z.number().nullish(),
    rca: z.number().nullish(),
    remark: z.string().nullish(),
    sec: z.number().nullish(),
    soundPressureLevel: z.number().nullish(),
    sup: z.number().nullish(),
    tra: z.number().nullish(),
    utilization: z.string().nullish(),
    volume: z.number().nullish()
  })
}

export function CreateShareLinkInputSchema() {
  return z.object({
    id: z.string()
  })
}

export function CreateSpecialPriceGroupInputSchema() {
  return z.object({
    id: z.string(),
    parentPriceGroup: z.string().nullish(),
    productType: z.string()
  })
}

export function CreateTeamInputSchema() {
  return z.object({
    description: z.string().nullish(),
    id: z.string().nullish(),
    name: z.string()
  })
}

export function CreateTeamMemberInputSchema() {
  return z.object({
    email: z.string(),
    role: z.string()
  })
}

export function DataTableSchema() {
  return z.object({
    __typename: z.literal("DataTable"),
    body: z
      .array(z.array(z.lazy(() => DataTableCellSchema())).nullish())
      .nullish(),
    description: z.string().nullish(),
    header: z.array(z.lazy(() => DataTableCellSchema())).nullish()
  })
}

export function DataTableCellSchema() {
  return z.object({
    __typename: z.literal("DataTableCell"),
    className: z.string().nullish(),
    index: z.number().nullish(),
    key: z.string().nullish(),
    value: z.any().nullish()
  })
}

export function DeleteResponseSchema() {
  return z.object({
    __typename: z.literal("DeleteResponse"),
    success: z.boolean()
  })
}

export function DeliveryTimeActiveImportSchema() {
  return z.object({
    __typename: z.literal("DeliveryTimeActiveImport"),
    contentLength: z.number(),
    fileName: z.string(),
    importedAt: z.string(),
    readUrl: z.string(),
    status: z.string(),
    uploaderEmail: z.string(),
    uploaderName: z.string()
  })
}

export function DimConfigurationSchema() {
  return z.object({
    __typename: z.literal("DimConfiguration"),
    dimensioningKey: z.string().nullish(),
    id: z.string(),
    isActive: z.boolean().nullish(),
    productName: z.string(),
    productType: z.string()
  })
}

export function DimensioningOptionSchema() {
  return z.object({
    __typename: z.literal("DimensioningOption"),
    configurationKey: z.string().nullish(),
    dimensioningKey: z.string(),
    physicalData: z
      .array(z.lazy(() => DimensioningPhysicalDataSchema()))
      .nullish(),
    properties: z.any().nullish(),
    variantKeyRelatedData: z
      .array(z.lazy(() => DimensioningParameterSchema()))
      .nullish()
  })
}

export function DimensioningParameterSchema() {
  return z.object({
    __typename: z.literal("DimensioningParameter"),
    default: z.any().nullish(),
    readOnly: z.boolean().nullish(),
    title: z.string().nullish(),
    type: z.string().nullish(),
    unit: z.string().nullish()
  })
}

export function DimensioningPhysicalDataSchema() {
  return z.union([DataTableSchema(), DimensioningParameterSchema()])
}

export function DuplicateEntityInputSchema() {
  return z.object({
    desiredId: z.string().nullish(),
    id: z.string(),
    label: z.string().nullish(),
    position: z.number().nullish(),
    recursive: z.boolean(),
    source: z.lazy(() => JsonapiRelationshipDataSchema()),
    target: z.lazy(() => JsonapiRelationshipDataSchema().nullish())
  })
}

export function ExternalDimensioningConfigurationSchema() {
  return z.object({
    __typename: z.literal("ExternalDimensioningConfiguration"),
    accessories: z.array(z.string()),
    dimensioningKey: z.string(),
    errors: z.array(z.lazy(() => ApiErrorSchema())).nullish(),
    id: z.string(),
    productType: z.string(),
    variantKey: z.string()
  })
}

export function ExternalDimensioningResultSchema() {
  return z.object({
    __typename: z.literal("ExternalDimensioningResult"),
    dllVersion: z.string().nullish(),
    environmentalVars: z.array(z.any().nullable()).nullish(),
    language: z.string().nullish(),
    supplementaryText: z
      .array(z.lazy(() => ExternalDimensioningSupplementaryTextSchema()))
      .nullish(),
    technicalData: z
      .array(z.lazy(() => ExternalDimensioningTechnicalDataSchema()))
      .nullish(),
    technicalInput: z
      .array(z.lazy(() => ExternalDimensioningTechnicalInputSchema()))
      .nullish(),
    transactionId: z.string(),
    transferData: z.lazy(() =>
      ExternalDimensioningTransferDataSchema().nullish()
    ),
    variantKeyData: z.any().nullish()
  })
}

export function ExternalDimensioningResultInputSchema() {
  return z.object({
    dllVersion: z.string().nullish(),
    environmentalVars: z.any().nullish(),
    language: z.string().nullish(),
    supplementaryText: z
      .array(z.lazy(() => ExternalDimensioningSupplementaryTextInputSchema()))
      .nullish(),
    technicalData: z
      .array(z.lazy(() => ExternalDimensioningTechnicalDataInputSchema()))
      .nullish(),
    technicalInput: z
      .array(z.lazy(() => ExternalDimensioningTechnicalInputInputSchema()))
      .nullish(),
    transactionId: z.string(),
    transferData: z.lazy(() =>
      ExternalDimensioningTransferDataInputSchema().nullish()
    ),
    variantKeyData: z.any().nullish()
  })
}

export function ExternalDimensioningSupplementaryTextSchema() {
  return z.object({
    __typename: z.literal("ExternalDimensioningSupplementaryText"),
    text: z.string()
  })
}

export function ExternalDimensioningSupplementaryTextInputSchema() {
  return z.object({
    text: z.string()
  })
}

export function ExternalDimensioningTechnicalDataSchema() {
  return z.union([
    ExternalDimensioningTechnicalDataDllVersionSchema(),
    ExternalDimensioningTechnicalDataTableSchema()
  ])
}

export function ExternalDimensioningTechnicalDataDllVersionSchema() {
  return z.object({
    __typename: z.literal("ExternalDimensioningTechnicalDataDllVersion"),
    dllVersion: z.string(),
    type: z.string().nullish()
  })
}

export function ExternalDimensioningTechnicalDataInputSchema() {
  return z.object({
    content: z.any().nullish(),
    dllVersion: z.string().nullish(),
    header: z.array(z.string()).nullish(),
    summary: z.string().nullish(),
    type: z.string().nullish()
  })
}

export function ExternalDimensioningTechnicalDataTableSchema() {
  return z.object({
    __typename: z.literal("ExternalDimensioningTechnicalDataTable"),
    content: z.any().nullish(),
    header: z.array(z.string()).nullish(),
    summary: z.string().nullish(),
    type: z.string().nullish()
  })
}

export function ExternalDimensioningTechnicalInputSchema() {
  return z.object({
    __typename: z.literal("ExternalDimensioningTechnicalInput"),
    label: z.string().nullish(),
    name: z.string(),
    unit: z.string().nullish(),
    userSelected: z.boolean(),
    value: z.any().nullish()
  })
}

export function ExternalDimensioningTechnicalInputInputSchema() {
  return z.object({
    label: z.string().nullish(),
    name: z.string(),
    unit: z.string().nullish(),
    userSelected: z.boolean(),
    value: z.any().nullish()
  })
}

export function ExternalDimensioningTransferDataSchema() {
  return z.object({
    __typename: z.literal("ExternalDimensioningTransferData"),
    origin: z.string().nullish()
  })
}

export function ExternalDimensioningTransferDataInputSchema() {
  return z.object({
    origin: z.string().nullish()
  })
}

export function ExternalDimensioningVariantKeyDataSchema() {
  return z.object({
    __typename: z.literal("ExternalDimensioningVariantKeyData"),
    dimensioningRelevant: z.boolean(),
    position: z.number(),
    value: z.string()
  })
}

export function ExternalDimensioningVariantKeyDataInputSchema() {
  return z.object({
    dimensioningRelevant: z.boolean(),
    position: z.number(),
    value: z.string()
  })
}

export function ExternalUsersDailyOverviewSchema() {
  return z.object({
    __typename: z.literal("ExternalUsersDailyOverview"),
    last7: z.lazy(() => ExternalUsersDailyOverviewLastDaysSchema()),
    last30: z.lazy(() => ExternalUsersDailyOverviewLastDaysSchema())
  })
}

export function ExternalUsersDailyOverviewLastDaysSchema() {
  return z.object({
    __typename: z.literal("ExternalUsersDailyOverviewLastDays"),
    logins: z.number(),
    signups: z.number()
  })
}

export function FloorSchema() {
  return z.object({
    __typename: z.literal("Floor"),
    children: z.array(z.lazy(() => RoomSchema())).nullish(),
    createdAt: z.string(),
    hasClarificationRequest: z.boolean().nullish(),
    id: z.string(),
    label: z.string().nullish(),
    parent: z.lazy(() => ProjectSchema().nullish()),
    position: z.number(),
    remark: z.string().nullish(),
    updatedAt: z.string()
  })
}

export function FloorPriceSchema() {
  return z.object({
    __typename: z.literal("FloorPrice"),
    currency: z.string(),
    groups: z.array(z.lazy(() => PriceGroupSchema())).nullish(),
    id: z.string(),
    isComplete: z.boolean(),
    isValid: z.boolean().nullish(),
    priceTotal: z.number()
  })
}

export function FollowUpConfigurationSchema() {
  return z.object({
    __typename: z.literal("FollowUpConfiguration"),
    id: z.string(),
    isActive: z.boolean().nullish(),
    label: z.string().nullish(),
    position: z.number(),
    sourceProduct: z.lazy(() => DimConfigurationSchema()),
    targetProduct: z.lazy(() => DimConfigurationSchema())
  })
}

export function HealthSchema() {
  return z.object({
    __typename: z.literal("Health"),
    isAvailable: z.boolean()
  })
}

export function InflationSurchargeSchema() {
  return z.object({
    __typename: z.literal("InflationSurcharge"),
    value: z.number().nullish()
  })
}

export function JsonapiRelationshipDataSchema() {
  return z.object({
    id: z.string(),
    type: z.string()
  })
}

export function NeoletterUserProfileSchema() {
  return z.object({
    __typename: z.literal("NeoletterUserProfile"),
    company: z.string().nullish(),
    custom_fields: z.lazy(() =>
      NeoletterUserProfileCustomFieldsSchema().nullish()
    ),
    dummy_property: z.string().nullish(),
    email: z.string().nullish(),
    family_name: z.string().nullish(),
    given_name: z.string().nullish(),
    id: z.string(),
    name: z.string().nullish(),
    phone_number: z.string().nullish(),
    position: z.string().nullish(),
    salutation: z.string().nullish(),
    staff: z.boolean().nullish()
  })
}

export function NeoletterUserProfileCustomFieldsSchema() {
  return z.object({
    __typename: z.literal("NeoletterUserProfileCustomFields"),
    active_project_id: z.string().nullish(),
    sidebar_is_expanded: z.string().nullish()
  })
}

export function NeoletterUserProfileCustomFieldsInputSchema() {
  return z.object({
    active_project_id: z.string().nullish(),
    sidebar_is_expanded: z.string().nullish()
  })
}

export function NeoletterUserProfileInputSchema() {
  return z.object({
    company: z.string().nullish(),
    custom_fields: z.lazy(() =>
      NeoletterUserProfileCustomFieldsInputSchema().nullish()
    ),
    email: z.string().nullish(),
    family_name: z.string().nullish(),
    given_name: z.string().nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    phone_number: z.string().nullish(),
    position: z.string().nullish(),
    salutation: z.string().nullish(),
    staff: z.boolean().nullish()
  })
}

export function ParentSchema() {
  return z.object({
    __typename: z.literal("Parent"),
    id: z.string(),
    type: z.string()
  })
}

export function PhysicalAttributeSchema() {
  return z.object({
    __typename: z.literal("PhysicalAttribute"),
    label: z.string(),
    unit: z.string().nullish(),
    value: z.number().nullish()
  })
}

export function PriceGroupSchema() {
  return z.object({
    __typename: z.literal("PriceGroup"),
    groupType: z.string(),
    isComplete: z.boolean().nullish(),
    name: z.string(),
    parentPriceGroup: z.string(),
    priceTotal: z.number()
  })
}

export function PriceGroupsSchema() {
  return z.object({
    __typename: z.literal("PriceGroups"),
    id: z.string(),
    values: z.array(z.string()).nullish()
  })
}

export function PriceListSchema() {
  return z.object({
    __typename: z.literal("PriceList"),
    id: z.string(),
    isCurrent: z.boolean().nullish(),
    isValid: z.boolean().nullish(),
    title: z.string().nullish(),
    validityKey: z.string().nullish()
  })
}

export function ProcessSchema() {
  return z.object({
    __typename: z.literal("Process"),
    copyId: z.string().nullish(),
    createdAt: z.string().nullish(),
    error: z.string().nullish(),
    finished: z.boolean().nullish(),
    id: z.string(),
    options: z.lazy(() => ProcessOptionsSchema().nullish()),
    originId: z.string().nullish(),
    originType: z.string().nullish(),
    targetId: z.string().nullish(),
    targetType: z.string().nullish(),
    updatedAt: z.string().nullish()
  })
}

export function ProcessOptionsSchema() {
  return z.object({
    __typename: z.literal("ProcessOptions"),
    recursive: z.boolean().nullish()
  })
}

export function ProductAttributeSchema() {
  return z.object({
    __typename: z.literal("ProductAttribute"),
    label: z.string(),
    value: z.string(),
    valueShort: z.string().nullish()
  })
}

export function ProductConfigurationModelSchema() {
  return z.object({
    __typename: z.literal("ProductConfigurationModel"),
    dimUrl: z
      .array(z.lazy(() => ProductConfigurationModelDimInfoSchema()))
      .nullish(),
    followUps: z
      .array(z.lazy(() => ProductConfigurationModelFollowUpSchema()))
      .nullish(),
    id: z.string().nullish()
  })
}

export function ProductConfigurationModelDimInfoSchema() {
  return z.object({
    __typename: z.literal("ProductConfigurationModelDimInfo"),
    label: z.string(),
    url: z.string()
  })
}

export function ProductConfigurationModelFollowUpSchema() {
  return z.object({
    __typename: z.literal("ProductConfigurationModelFollowUp"),
    dimUrl: z
      .array(z.lazy(() => ProductConfigurationModelDimInfoSchema()))
      .nullish(),
    id: z.string().nullish()
  })
}

export function ProductConfigurationModelsSchema() {
  return z.object({
    __typename: z.literal("ProductConfigurationModels"),
    models: z.array(z.lazy(() => ProductConfigurationModelSchema())).nullish()
  })
}

export function ProductConfigurationResponseSchema() {
  return z.object({
    __typename: z.literal("ProductConfigurationResponse"),
    accessories: z.array(z.string()).nullish(),
    configurationKey: z.string().nullish(),
    dimensioningKey: z.string().nullish(),
    dimensioningOptions: z
      .array(z.lazy(() => DimensioningOptionSchema()))
      .nullish(),
    error: z.string().nullish(),
    errors: z.array(z.lazy(() => ApiErrorSchema())).nullish(),
    id: z.string(),
    originalConfiguration: z.lazy(() =>
      ProductConfigurationResponseSchema().nullish()
    ),
    productType: z.string().nullish(),
    schema: z.any().nullish(),
    variantKey: z.string().nullish()
  })
}

export function ProductDeliveryTimeSchema() {
  return z.object({
    __typename: z.literal("ProductDeliveryTime"),
    days: z.number().nullish(),
    quarter: z.number().nullish(),
    type: z.string(),
    week: z.number().nullish(),
    year: z.number().nullish()
  })
}

export function ProductDimensioningSchema() {
  return z.object({
    __typename: z.literal("ProductDimensioning"),
    environmentalAttributes: z
      .array(z.lazy(() => ProductAttributeSchema()))
      .nullish(),
    physicalAttributes: z
      .array(z.lazy(() => PhysicalAttributeSchema()))
      .nullish(),
    physicalTables: z.array(z.lazy(() => DataTableSchema())).nullish(),
    supplementaryText: z.string().nullish()
  })
}

export function ProductInformationSchema() {
  return z.object({
    __typename: z.literal("ProductInformation"),
    addons: z.array(z.lazy(() => ProductInformationSchema())).nullish(),
    attributes: z.array(z.lazy(() => ProductAttributeSchema())),
    attributesTable: z.lazy(() => DataTableSchema().nullish()),
    configurationKey: z.string().nullish(),
    deliveryTime: z.lazy(() => ProductDeliveryTimeSchema().nullish()),
    dimensioning: z.lazy(() => ProductDimensioningSchema().nullish()),
    generalDescription: z.lazy(() =>
      ProductInformationTextFieldSchema().nullish()
    ),
    picture: z.lazy(() => ProductPictureSchema().nullish()),
    price: z.number().nullish(),
    priceGroup: z.string().nullish(),
    productKind: z.string(),
    productType: z.string(),
    quickInfos: z.lazy(() => ProductInformationTextFieldSchema().nullish()),
    shortTitle: z.string(),
    title: z.string(),
    variantDescription: z.lazy(() =>
      ProductInformationTextFieldSchema().nullish()
    ),
    variantKey: z.string()
  })
}

export function ProductInformationTextFieldSchema() {
  return z.object({
    __typename: z.literal("ProductInformationTextField"),
    label: z.string(),
    value: z.string()
  })
}

export function ProductPictureSchema() {
  return z.object({
    __typename: z.literal("ProductPicture"),
    alternativeText: z.string().nullish(),
    title: z.string().nullish(),
    url: z.string()
  })
}

export function ProductPositionSchema() {
  return z.object({
    __typename: z.literal("ProductPosition"),
    addons: z.array(z.lazy(() => ProductPositionAddonSchema())).nullish(),
    configurationKey: z.string().nullish(),
    dimensioning: z.lazy(() => ExternalDimensioningResultSchema().nullish()),
    displayPosition: z.string().nullish(),
    hasClarificationRequest: z.boolean().nullish(),
    id: z.string(),
    isAlternative: z.boolean().nullish(),
    label: z.string().nullish(),
    parent: z.lazy(() => ProductPositionParentSchema().nullish()),
    position: z.number(),
    price: z.number().nullish(),
    priceGroup: z.string().nullish(),
    quantity: z.number(),
    references: z
      .array(z.lazy(() => ProductPositionInstallationReferenceSchema()))
      .nullish(),
    remark: z.string().nullish(),
    variantKey: z.string()
  })
}

export function ProductPositionAddonSchema() {
  return z.object({
    __typename: z.literal("ProductPositionAddon"),
    id: z.string(),
    parentProductType: z.string(),
    variantKey: z.string()
  })
}

export function ProductPositionInstallationReferenceSchema() {
  return z.object({
    __typename: z.literal("ProductPositionInstallationReference"),
    id: z.string(),
    permalink: z.string(),
    position: z.number(),
    title: z.string().nullish()
  })
}

export function ProductPositionInstallationReferenceInputSchema() {
  return z.object({
    id: z.string(),
    permalink: z.string(),
    position: z.number(),
    title: z.string().nullish()
  })
}

export function ProductPositionParentSchema() {
  return z.union([ProjectSchema(), RoomSchema()])
}

export function ProductPriceSchema() {
  return z.object({
    __typename: z.literal("ProductPrice"),
    currency: z.string(),
    groups: z.array(z.lazy(() => PriceGroupSchema())).nullish(),
    id: z.string(),
    isComplete: z.boolean(),
    isValid: z.boolean().nullish(),
    itemPrice: z.number(),
    priceTotal: z.number(),
    vat: z.number().nullish(),
    vatRate: z.number().nullish()
  })
}

export function ProfileDeleteCodeSubmitInputSchema() {
  return z.object({
    securityCode: z.string()
  })
}

export function ProjectSchema() {
  return z.object({
    __typename: z.literal("Project"),
    children: z.array(z.lazy(() => ProjectChildSchema())).nullish(),
    createdAt: z.string(),
    description: z.string().nullish(),
    hasClarificationRequest: z.boolean().nullish(),
    id: z.string(),
    inflationSurcharge: z.number().nullish(),
    lastChanged: z.string().nullish(),
    lastChangedBy: z.lazy(() => UserSchema().nullish()),
    phase: z.lazy(() => ProjectPhaseSchema().nullish()),
    position: z.number(),
    priceList: z.string().nullish(),
    specialPriceGroups: z
      .array(z.lazy(() => SpecialPriceGroupSchema()))
      .nullish(),
    team: z.lazy(() => ProjectTeamIdSchema().nullish()),
    title: z.string(),
    ui: z.lazy(() => ProjectUiSchema().nullish()),
    updatedAt: z.string()
  })
}

export function ProjectAttachmentCategoriesSchema() {
  return z.object({
    __typename: z.literal("ProjectAttachmentCategories"),
    categories: z.array(z.lazy(() => SelectOptionTypeSchema())),
    id: z.string()
  })
}

export function ProjectChildSchema() {
  return z.union([FloorSchema(), ProductPositionSchema(), RoomSchema()])
}

export function ProjectElementSchema() {
  return z.union([
    FloorSchema(),
    ProductPositionSchema(),
    ProjectSchema(),
    RoomSchema()
  ])
}

export function ProjectHistorySchema() {
  return z.object({
    __typename: z.literal("ProjectHistory"),
    entries: z.array(z.lazy(() => ProjectHistoryEntrySchema())),
    id: z.string(),
    links: z.lazy(() => ProjectHistoryLinksSchema())
  })
}

export function ProjectHistoryChangeSchema() {
  return z.object({
    __typename: z.literal("ProjectHistoryChange"),
    field: z.string(),
    newValue: z.string().nullish(),
    oldValue: z.string().nullish()
  })
}

export function ProjectHistoryEntitySchema() {
  return z.object({
    __typename: z.literal("ProjectHistoryEntity"),
    displayPosition: z.string().nullish(),
    id: z.string(),
    label: z.string().nullish(),
    type: z.string(),
    variantKey: z.string().nullish()
  })
}

export function ProjectHistoryEntrySchema() {
  return z.object({
    __typename: z.literal("ProjectHistoryEntry"),
    action: z.string(),
    changes: z.array(z.lazy(() => ProjectHistoryChangeSchema())).nullish(),
    entity: z.lazy(() => ProjectHistoryEntitySchema()),
    entityId: z.string(),
    entityType: z.string(),
    fromEntity: z.lazy(() => ProjectHistoryEntitySchema()),
    id: z.string(),
    label: z.string().nullish(),
    project: z.lazy(() => ProjectHistoryProjectSchema()),
    timestamp: z.string(),
    toEntity: z.lazy(() => ProjectHistoryEntitySchema()),
    user: z.lazy(() => ProjectHistoryUserSchema())
  })
}

export function ProjectHistoryLinksSchema() {
  return z.object({
    __typename: z.literal("ProjectHistoryLinks"),
    next: z.string().nullish(),
    prev: z.string().nullish()
  })
}

export function ProjectHistoryProjectSchema() {
  return z.object({
    __typename: z.literal("ProjectHistoryProject"),
    id: z.string(),
    title: z.string().nullish(),
    type: z.string()
  })
}

export function ProjectHistoryUserSchema() {
  return z.object({
    __typename: z.literal("ProjectHistoryUser"),
    email: z.string().nullish(),
    id: z.string(),
    name: z.string().nullish(),
    type: z.string()
  })
}

export function ProjectImportSchema() {
  return z.object({
    __typename: z.literal("ProjectImport"),
    error: z.array(z.lazy(() => ProjectImportErrorSchema())).nullish(),
    id: z.string(),
    status: z.string().nullish()
  })
}

export function ProjectImportErrorSchema() {
  return z.object({
    __typename: z.literal("ProjectImportError"),
    errors: z.array(z.string()).nullish(),
    isValid: z.boolean().nullish(),
    rowIndex: z.number().nullish(),
    warnings: z.array(z.string()).nullish()
  })
}

export function ProjectImportProjectFieldsInputSchema() {
  return z.object({
    id: z.string(),
    phaseId: z.string(),
    title: z.string()
  })
}

export function ProjectKpiSchema() {
  return z.object({
    __typename: z.literal("ProjectKpi"),
    id: z.string(),
    projectsCount: z.lazy(() => ProjectsCountSchema())
  })
}

export function ProjectParentSchema() {
  return z.union([FloorSchema(), ProjectSchema(), RoomSchema()])
}

export function ProjectPermissionsSchema() {
  return z.object({
    __typename: z.literal("ProjectPermissions"),
    create_special_price_group: z.boolean(),
    delete_project: z.boolean(),
    edit_position_price: z.boolean(),
    edit_position_price_group: z.boolean(),
    edit_project: z.boolean(),
    invite_members: z.boolean(),
    view_project: z.boolean()
  })
}

export function ProjectPhaseSchema() {
  return z.object({
    __typename: z.literal("ProjectPhase"),
    id: z.string(),
    label: z.string(),
    value: z.string()
  })
}

export function ProjectPriceSchema() {
  return z.object({
    __typename: z.literal("ProjectPrice"),
    currency: z.string(),
    groups: z.array(z.lazy(() => PriceGroupSchema())).nullish(),
    id: z.string(),
    isComplete: z.boolean(),
    isValid: z.boolean().nullish(),
    priceTotal: z.number()
  })
}

export function ProjectTeamIdSchema() {
  return z.object({
    __typename: z.literal("ProjectTeamID"),
    id: z.string()
  })
}

export function ProjectUiSchema() {
  return z.object({
    __typename: z.literal("ProjectUI"),
    color: z.string().nullish()
  })
}

export function ProjectUiInputSchema() {
  return z.object({
    color: z.string().nullish()
  })
}

export function ProjectsCountSchema() {
  return z.object({
    __typename: z.literal("ProjectsCount"),
    dailyOverview: z.lazy(() => ProjectsDailyOverviewSchema().nullish()),
    total: z.number()
  })
}

export function ProjectsDailyOverviewSchema() {
  return z.object({
    __typename: z.literal("ProjectsDailyOverview"),
    last7: z.number(),
    last30: z.number()
  })
}

export function RegistrationsSchema() {
  return z.object({
    __typename: z.literal("Registrations"),
    email: z.number(),
    google: z.number(),
    linkedin: z.number(),
    microsoft: z.number(),
    total: z.number()
  })
}

export function RoomSchema() {
  return z.object({
    __typename: z.literal("Room"),
    airVolumePerArea: z.number().nullish(),
    airVolumePerPerson: z.number().nullish(),
    area: z.number().nullish(),
    children: z.array(z.lazy(() => ProductPositionSchema())).nullish(),
    createdAt: z.string(),
    eha: z.number().nullish(),
    eta: z.number().nullish(),
    hasClarificationRequest: z.boolean().nullish(),
    height: z.number().nullish(),
    id: z.string(),
    ida: z.number().nullish(),
    label: z.string().nullish(),
    number: z.string(),
    oda: z.number().nullish(),
    parent: z.lazy(() => RoomParentSchema().nullish()),
    personsNumber: z.number().nullish(),
    position: z.number(),
    rca: z.number().nullish(),
    remark: z.string().nullish(),
    sec: z.number().nullish(),
    soundPressureLevel: z.number().nullish(),
    sup: z.number().nullish(),
    tra: z.number().nullish(),
    updatedAt: z.string(),
    utilization: z.string().nullish(),
    volume: z.number().nullish()
  })
}

export function RoomParentSchema() {
  return z.union([FloorSchema(), ProjectSchema()])
}

export function RoomPriceSchema() {
  return z.object({
    __typename: z.literal("RoomPrice"),
    currency: z.string(),
    groups: z.array(z.lazy(() => PriceGroupSchema())).nullish(),
    id: z.string(),
    isComplete: z.boolean(),
    isValid: z.boolean().nullish(),
    priceTotal: z.number()
  })
}

export function SelectOptionTypeSchema() {
  return z.object({
    __typename: z.literal("SelectOptionType"),
    label: z.string(),
    value: z.string()
  })
}

export function ShareLinkSchema() {
  return z.object({
    __typename: z.literal("ShareLink"),
    id: z.string()
  })
}

export function SpecialPriceGroupSchema() {
  return z.object({
    __typename: z.literal("SpecialPriceGroup"),
    id: z.string(),
    name: z.string(),
    parentPriceGroup: z.string().nullish(),
    productType: z.string()
  })
}

export function TeamSchema() {
  return z.object({
    __typename: z.literal("Team"),
    createdAt: z.string(),
    description: z.string().nullish(),
    id: z.string(),
    memberships: z.array(z.lazy(() => TeamMemberSchema())),
    name: z.string(),
    projects: z.array(z.lazy(() => ProjectSchema())).nullish(),
    updatedAt: z.string()
  })
}

export function TeamInvitationSchema() {
  return z.object({
    __typename: z.literal("TeamInvitation"),
    acceptInvitationPath: z.string(),
    id: z.string(),
    invitationAccepted: z.boolean(),
    invitationAcceptedAt: z.string().nullish(),
    invitationRejected: z.boolean().nullish(),
    invitedBy: z.lazy(() => UserSchema().nullish()),
    role: z.string(),
    team: z.lazy(() => TeamSchema()),
    user: z.lazy(() => UserSchema().nullish())
  })
}

export function TeamMemberSchema() {
  return z.object({
    __typename: z.literal("TeamMember"),
    createdAt: z.string(),
    id: z.string(),
    invitationAccepted: z.boolean(),
    invitationAcceptedAt: z.string().nullish(),
    invitedAt: z.string().nullish(),
    isCurrentUser: z.boolean().nullish(),
    role: z.string(),
    updatedAt: z.string(),
    user: z.lazy(() => UserSchema().nullish())
  })
}

export function TeamProjectsSchema() {
  return z.object({
    __typename: z.literal("TeamProjects"),
    id: z.string(),
    projects: z.array(z.lazy(() => ProjectSchema()))
  })
}

export function UpdateAttachmentInputSchema() {
  return z.object({
    fileName: z.string(),
    id: z.string(),
    title: z.string().nullish()
  })
}

export function UpdateClarificationRequestInputSchema() {
  return z.object({
    content: z.string(),
    id: z.string()
  })
}

export function UpdateDimConfigurationInputSchema() {
  return z.object({
    dimensioningKey: z.string().nullish(),
    isActive: z.boolean().nullish(),
    productName: z.string().nullish(),
    productType: z.string().nullish()
  })
}

export function UpdateFloorInputSchema() {
  return z.object({
    id: z.string(),
    label: z.string().nullish(),
    parent: z.lazy(() => JsonapiRelationshipDataSchema().nullish()),
    position: z.number().nullish(),
    remark: z.string().nullish()
  })
}

export function UpdateFollowUpConfigurationInputSchema() {
  return z.object({
    isActive: z.boolean().nullish(),
    label: z.string().nullish(),
    position: z.number().nullish()
  })
}

export function UpdateProductPositionInputSchema() {
  return z.object({
    configurationKey: z.string().nullish(),
    dimensioning: z.lazy(() =>
      ExternalDimensioningResultInputSchema().nullish()
    ),
    displayPosition: z.string().nullish(),
    id: z.string(),
    isAlternative: z.boolean().nullish(),
    label: z.string().nullish(),
    parent: z.lazy(() => JsonapiRelationshipDataSchema().nullish()),
    position: z.number().nullish(),
    price: z.number().nullish(),
    priceGroup: z.string().nullish(),
    quantity: z.number().nullish(),
    references: z
      .array(z.lazy(() => ProductPositionInstallationReferenceInputSchema()))
      .nullish(),
    remark: z.string().nullish(),
    variantKey: z.string().nullish()
  })
}

export function UpdateProjectInputSchema() {
  return z.object({
    description: z.string().nullish(),
    id: z.string(),
    inflationSurcharge: z.number().nullish(),
    position: z.number().nullish(),
    priceList: z.string().nullish(),
    title: z.string().nullish(),
    ui: z.lazy(() => ProjectUiInputSchema().nullish())
  })
}

export function UpdateRoomInputSchema() {
  return z.object({
    airVolumePerArea: z.number().nullish(),
    airVolumePerPerson: z.number().nullish(),
    area: z.number().nullish(),
    eha: z.number().nullish(),
    eta: z.number().nullish(),
    height: z.number().nullish(),
    id: z.string(),
    ida: z.number().nullish(),
    label: z.string().nullish(),
    number: z.string().nullish(),
    oda: z.number().nullish(),
    parent: z.lazy(() => JsonapiRelationshipDataSchema().nullish()),
    personsNumber: z.number().nullish(),
    position: z.number().nullish(),
    rca: z.number().nullish(),
    remark: z.string().nullish(),
    sec: z.number().nullish(),
    soundPressureLevel: z.number().nullish(),
    sup: z.number().nullish(),
    tra: z.number().nullish(),
    utilization: z.string().nullish(),
    volume: z.number().nullish()
  })
}

export function UpdateTeamInputSchema() {
  return z.object({
    description: z.string().nullish(),
    id: z.string(),
    name: z.string()
  })
}

export function UpdateTeamMemberInputSchema() {
  return z.object({
    email: z.string().nullish(),
    id: z.string(),
    role: z.string().nullish()
  })
}

export function UserSchema() {
  return z.object({
    __typename: z.literal("User"),
    createdAt: z.string(),
    email: z.string(),
    id: z.string(),
    name: z.string().nullish(),
    updatedAt: z.string()
  })
}

export function UserKpiSchema() {
  return z.object({
    __typename: z.literal("UserKpi"),
    activeUsers: z.lazy(() => ActiveUsersSchema()),
    dailyOverview: z.lazy(() => UsersDailyOverviewSchema()),
    id: z.string(),
    registrations: z.lazy(() => RegistrationsSchema()),
    usersCount: z.lazy(() => UsersCountSchema())
  })
}

export function UserPermissionSchema() {
  return z.object({
    __typename: z.literal("UserPermission"),
    id: z.string(),
    permissions: z.lazy(() => ProjectPermissionsSchema().nullish()),
    resourceId: z.string(),
    resourceType: z.string(),
    role: z.string()
  })
}

export function UserRolesSchema() {
  return z.object({
    __typename: z.literal("UserRoles"),
    email: z.string(),
    id: z.string(),
    name: z.string(),
    roles: z.array(z.string()).nullish()
  })
}

export function UsersCountSchema() {
  return z.object({
    __typename: z.literal("UsersCount"),
    external: z.number(),
    internal: z.number(),
    total: z.number()
  })
}

export function UsersDailyOverviewSchema() {
  return z.object({
    __typename: z.literal("UsersDailyOverview"),
    external: z.lazy(() => ExternalUsersDailyOverviewSchema())
  })
}

export function VerifyCodeInputSchema() {
  return z.object({
    code: z.string()
  })
}

export function VerifyCodeInputResponseSchema() {
  return z.object({
    __typename: z.literal("VerifyCodeInputResponse"),
    attemptsLeft: z.number(),
    valid: z.boolean()
  })
}
